import { uniqueId } from 'lodash-es';
import { GlTooltipDirective, GlButton, GlLink, GlTruncate } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { sprintf, __ } from '~/locale';
import defaultAvatarUrl from 'images/no_avatar.png';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import TimeagoTooltip from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/time_ago_tooltip.vue?vue3';
import UserAvatarImage from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/user_avatar/user_avatar_image.vue?vue3';
import CommitPopover from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/source_viewer/components/commit_popover.vue?vue3';
export default {
    name: 'BlameCommitInfo',
    components: {
        GlButton,
        GlLink,
        GlTruncate,
        TimeagoTooltip,
        UserAvatarImage,
        CommitPopover
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        commit: {
            type: Object,
            required: true
        },
        previousBlamePath: {
            type: String,
            required: false,
            default: null
        }
    },
    data () {
        return {
            popoverTargetId: uniqueId('blame-commit-popover-')
        };
    },
    computed: {
        commitTitle () {
            return this.commit.title || '';
        },
        avatarLinkAltText () {
            return sprintf(__(`%{username}'s avatar`), {
                username: this.commit.authorName
            });
        },
        avatarUrl () {
            return this.commit.authorGravatar || this.commit.avatarUrl || this.$options.defaultAvatarUrl;
        },
        commitUrl () {
            return this.commit.webPath || this.commit.commitUrl;
        },
        hasMessage () {
            return Boolean(this.commit.message || this.commit.title);
        },
        author () {
            return this.commit.author;
        },
        authorUserId () {
            return this.author?.id ? getIdFromGraphQLId(this.author.id) : null;
        },
        authorUsername () {
            return this.author?.username || '';
        },
        authorWebPath () {
            return this.author?.webPath || '';
        },
        avatarWrapperProps () {
            if (!this.author) return {};
            return {
                href: this.authorWebPath,
                'data-user-id': this.authorUserId,
                'data-username': this.authorUsername,
                class: 'js-user-link',
                'data-testid': 'commit-author-link'
            };
        }
    },
    defaultAvatarUrl,
    i18n: {
        viewBlamePrior: __('View blame prior to this change')
    }
};
